import { DOCUMENT_LANG } from 'js/core/constants';

// Translations
import 'hyperform-l10n/dist/hyperform.nl';

// Set locale
hyperform.setLanguage(DOCUMENT_LANG);


// Initialize
hyperform(window);

// Insert error messages as last child of parent
hyperform.setRenderer('attachWarning', (warning, element) => element.parentNode.appendChild(warning));
